// client/src/pages/Home.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';

const Home = () => {
  const navigate = useNavigate();
  const [playerName, setPlayerName] = useState('');
  const [gameId, setGameId] = useState('');
  const [error, setError] = useState('');
  const [activeTab, setActiveTab] = useState('create'); // 'create' or 'join'

  // Load player name from localStorage if available
  useEffect(() => {
    const savedName = localStorage.getItem('playerName');
    if (savedName) {
      setPlayerName(savedName);
    }
  }, []);

  const handleCreateGame = (e) => {
    e.preventDefault();
    if (!playerName.trim()) {
      setError('Please enter your name');
      return;
    }
    
    // Save player name to localStorage
    localStorage.setItem('playerName', playerName);
    
    // Navigate to the game
    navigate('/game');
  };

  const handleJoinGame = (e) => {
    e.preventDefault();
    if (!playerName.trim()) {
      setError('Please enter your name');
      return;
    }
    if (!gameId.trim()) {
      setError('Please enter a game ID');
      return;
    }
    
    // Save player name to localStorage
    localStorage.setItem('playerName', playerName);
    
    // Navigate to the game with the game ID
    navigate(`/game/${gameId}`);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setError('');
  };

  return (
    <div className="home-container">
      <div className="home-content">
        <div className="home-header">
          <h1 className="game-title">Gibberers</h1>
          <p className="game-tagline">Create a new language with friends!</p>
        </div>

        <div className="card">
          <div className="card-tabs">
            <button 
              className={`tab-button ${activeTab === 'create' ? 'active' : ''}`}
              onClick={() => handleTabChange('create')}
            >
              Create Game
            </button>
            <button 
              className={`tab-button ${activeTab === 'join' ? 'active' : ''}`}
              onClick={() => handleTabChange('join')}
            >
              Join Game
            </button>
          </div>

          <div className="card-content">
            {error && <div className="error-message">{error}</div>}
            
            <div className="input-group">
              <label htmlFor="playerName">Your Name</label>
              <input
                id="playerName"
                type="text"
                value={playerName}
                onChange={(e) => setPlayerName(e.target.value)}
                placeholder="Enter your name"
                className="text-input"
              />
            </div>

            {activeTab === 'create' ? (
              <form onSubmit={handleCreateGame}>
                <p className="info-text">
                  Create a new game and invite friends to join using your game ID.
                </p>
                <button type="submit" className="primary-button create-button">
                  Create New Game
                </button>
              </form>
            ) : (
              <form onSubmit={handleJoinGame}>
                <div className="input-group">
                  <label htmlFor="gameId">Game ID</label>
                  <input
                    id="gameId"
                    type="text"
                    value={gameId}
                    onChange={(e) => setGameId(e.target.value)}
                    placeholder="Enter the game ID"
                    className="text-input"
                  />
                </div>
                <button type="submit" className="primary-button join-button">
                  Join Game
                </button>
              </form>
            )}
          </div>
        </div>

        <div className="game-instructions">
          <h2>How to Play</h2>
          <div className="instructions-content">
            <div className="instruction-step">
              <div className="step-number">1</div>
              <div className="step-text">
                <h3>Create or Join a Game</h3>
                <p>Start a new game or join an existing one with a game ID.</p>
              </div>
            </div>
            <div className="instruction-step">
              <div className="step-number">2</div>
              <div className="step-text">
                <h3>Invent New Words</h3>
                <p>Create new spellings for words in the Gibberers language.</p>
              </div>
            </div>
            <div className="instruction-step">
              <div className="step-number">3</div>
              <div className="step-text">
                <h3>Build a Dictionary</h3>
                <p>Collaborate with friends to build a unique language dictionary.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;